import { get, post } from ".";

export const getQTOIDApi = async (projectId) => {
  return await get(`project/${projectId}/qto`);
};

export const uploadNewQTOApi = async (projectId, params) => {
  return await post(`project/${projectId}/qto/new-qto`, params);
};

export const exportQTOApi = async (projectId) => {
  return await get(`project/${projectId}/qto/export-qto`);
};

export const QTOhistoryApi = async (projectId) => {
  return await get(`project/${projectId}/qto/qto-history`);
};

export const exportQTOTemplateApi = async (projectId) => {
  return await get(`project/${projectId}/qto/export-qto-template`);
};

export const getMissingQTOApi = async (projectId) => {
  return await get(`project/${projectId}/qto/qto-missing-alert`);
};

export const getQTOElementsApi = async (projectId, qtoId) => {
  return await get(`project/${projectId}/qto/qto-elements?qtoId=${qtoId}`);
};

export const updateQTOQuantityApi = async (projectId, qtoId, params) => {
  return await post(`project/${projectId}/qto/update-base-quantity?qtoId=${qtoId}`, params);
};